module.exports = __webpack_public_path__ + "fonts/roboto-v30-latin-900.b20371a6.woff2";